var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
export default function Image(props) {
    const { path } = props, imgProps = __rest(props, ["path"]);
    const cdn = window.SPEEDCURVE_CONFIG ? window.SPEEDCURVE_CONFIG.imageCdn : "/";
    const src = path ? `${cdn}${path}` : props.src;
    /*TODO: Handle setting up the ImageX url for the image along with the retina versions like below.
    <img
      srcset="https://assets.imgix.net/examples/bluehat.jpg?w=400&dpr=1 1x,
              https://assets.imgix.net/examples/bluehat.jpg?w=400&dpr=2 2x,
              https://assets.imgix.net/examples/bluehat.jpg?w=400&dpr=3 3x"
      src="https://assets.imgix.net/examples/bluehat.jpg?w=400">
   */
    return _jsx("img", Object.assign({ src: src }, imgProps));
}
